export const BAND_EMAIL = 'SamuelJohnBand@gmail.com';
